// frontend/src/api.js
import axios from "axios";

// 1) API root (no trailing slash). In Amplify set:
// REACT_APP_API_URL = https://<your-apprunner>.awsapprunner.com
const API_ROOT =
  (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "") || "http://127.0.0.1:8000";

// 2) Final base for this service
const API_BASE = `${API_ROOT}/api/v1/masterplan`;

export const apiClient = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
  // withCredentials: true, // enable ONLY if you use cookies
});

// Optional: friendlier error surfacing
const unwrap = (err) => {
  if (err.response) {
    const { status, data } = err.response;
    const reason =
      typeof data === "string" ? data : JSON.stringify(data, null, 2);
    throw new Error(`HTTP ${status} - ${reason}`);
  }
  throw err; // network, CORS, DNS, etc.
};

export const sendUserData = async (userData) => {
  try {
    const { data } = await apiClient.post("/generate-first-draft", userData);
    return data;
  } catch (e) {
    throw unwrap(e);
  }
};

export const sendUserAudio = async (form) => {
  try {
    const { data } = await apiClient.post("/generate-first-draft-from-audio", form,
      { headers: { "Content-Type": undefined } }
    );
    return data;
  } catch (e) {
    throw unwrap(e);
  }
};

export const generateMasterplan = async (masterplanData) => {
  try {
    const { data } = await apiClient.post("/generate-masterplan", masterplanData);
    return data;
  } catch (e) {
    throw unwrap(e);
  }
};

export const sendReport = async (emailData) => {
  try {
    const { data } = await apiClient.post("/send-report", emailData);
    return data;
  } catch (e) {
    throw unwrap(e);
  }
};

export const refactorMasterplan = async (refactorData) => {
  try {
    const { data } = await apiClient.post("/refactor-masterplan", refactorData);
    return data;
  } catch (e) {
    throw unwrap(e);
  }
};

export const getMasterplan = async (masterplan_id) => {
  try {
    const { data } = await apiClient.get(`/${masterplan_id}`);
    return data;
  } catch (e) {
    throw unwrap(e);
  }
};
